const SourceMapSalesChannel = {
  ["public-form"]: "PUBLIC_FORM",
  ["marketing"]: "SALES_ORDER_LINK_MARKETING",
  ["directsales"]: "SALES_ORDER_LINK",
  ["agentsales"]: "SALES_ORDER_LINK"
}
export default SourceMapSalesChannel
